import script from "./AudioDragCountGame.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioDragCountGame.vue?vue&type=script&setup=true&lang=js"

import "./AudioDragCountGame.vue?vue&type=style&index=0&id=9974fe6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9974fe6a"]])

export default __exports__